import {Box, Checkbox, FormControlLabel, Typography} from '@mui/material';
import ResponsiveListContainer from '../../ResponsiveListContainer';
import FooterComponent from './FooterComponent';
import MobileDeliverySummarySingleRow from './SingleRow';
import mockCustomerProducts from './mocks';
import GeneralDatePickerComponent from '../../components/GeneralDatePickerComponent';
import CategoryChipsComponent from './CategoryChipsComponent';
import {MobileDeliveryDropdownOptions} from './DropdownOptions';
import {useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../../store";
import {getSpecificCustomer, selectCustomerById} from "../../../../../store/customers/customersSlice";
import {documentTypes} from "../../../../../types/DocumentsTypes/utils";
import React from "react";
import getCustomerProductsPrices from "../../../../../api/customer/products_prices.api";
import {dateObjectToString} from "../../../../../fromKotlin/nkutils";
import {getClientsDaily} from "../../../../../api/customer/documents.api";
import IItem from "../../../../../types/product_delivery";
import {useCreateCustomerDocument} from "../../../../../hooks/customer/documents.hooks";


const TitleComponent = ({label, customer, setDisplayedData, documentType,date,setDate}) => {
    return (
        <Box sx={{display: 'flex', maxHeight: '50px', padding: '5px 5px 0px 45px', alignItems: 'center'}}>
            <Typography
                sx={{display: 'flex', fontSize: '15px', fontWeight: 'bold', color: 'black', lineHeight: '15px'}}>
                {documentType.name} לכבוד: {customer?.name || 'משתמש לא נמצא'}
            </Typography>
            <GeneralDatePickerComponent mainContent={[]} setDisplayedData={setDisplayedData} singleDateMode={true} date={date} setDate={setDate}/>
        </Box>
    );
};


const MobileDeliverySummary = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id'); // Extract customer ID from query params
    const type = searchParams.get('type'); // Extract document type from query params
    const dateq = searchParams.get('date'); // Extract document type from query params
    const [date, setDate] = React.useState(dateq ? new Date(dateq): new Date());
    const [withReturns, setWithReturns] = React.useState<boolean>(parseInt(localStorage.getItem('withReturns') ?? '0') == 1);
    const dispatch = useDispatch();
    const customer = useSelector((state: RootState) => selectCustomerById(state, id));
    const documentType = documentTypes[type as string]
    const [products, setProducts] = React.useState<IItem[]>([]);
    const createCustomerDocument = useCreateCustomerDocument(id );
    React.useEffect(() => {
        if (!customer) dispatch(getSpecificCustomer(Number(id)));
    }, [dispatch]);
    let counter = 0;
    const onProductChange = React.useCallback((product: IItem) => {
        setProducts((prevProducts) => {
                let seen = false;
                const x = prevProducts.map((p) => {

                        if (product.id === p.id) {
                            seen = true;
                            return product;
                        }
                        return p;
                    }
                );
                if (!seen) {

                    x.push(product);
                }

                if (product.notePlacement == undefined) {
                    product.notePlacement = counter;
                    counter += 1;
                }
                return x;

            }
        );
    }, []);
    React.useEffect(() => {
        const genProds = async () => {
            const ps = await getCustomerProductsPrices(id , dateObjectToString(date), false, undefined, undefined, true);
            products.forEach((p) => {
                const found = ps.find((pr) => pr.id === p.id);
                if (found) {
                    found.quantity = p.quantity;
                    found.quantityReturns = p.quantityReturns;
                    found.quantitySecond = p.quantitySecond;
                    found.notePlacement = p.notePlacement;
                }
            })
            setProducts(ps);

        };
        genProds();

    }, [date,]);
    const handleWithReturnsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.checked;
        setWithReturns(val);
        localStorage.setItem('withReturns', val ? '1' : '0');
    };
    if (!customer || (!id )) return <Box/>;
    return (
        <>
            <ResponsiveListContainer
                TitleComponent={(props) => (
                    <>
                        <TitleComponent {...props} customer={customer} documentType={documentType} date={date} setDate={setDate}/>
                        <Box sx={{display: 'flex', padding: '0px 5px 0px 45px', alignItems: 'center'}}>
                            <FormControlLabel
                                control={<Checkbox checked={withReturns} onChange={handleWithReturnsChange} size="small"/>}
                                label={<Typography sx={{fontSize: '13px'}}>החזרות</Typography>}
                            />
                        </Box>
                    </>
                )}
                dropdownFilter={MobileDeliveryDropdownOptions}
                lowerChips={CategoryChipsComponent}
                FooterComponent={(props)=><FooterComponent documentType={type} products={products} customer={customer} date={date} createCustomerDocument={createCustomerDocument}/>}
                mainContent={products}
                setData={onProductChange}
                SingleRowComponent={MobileDeliverySummarySingleRow}
                outsideHooks={{withReturns}}
            />
        </>
    );
};

export default MobileDeliverySummary;
